import { z } from "zod";
import {
  TopolBlockCssClassSchema,
  TopolBlockSchema,
  TopolColorSchema,
  TopolColorBearingSchema,
} from "../commonSchema";

const defaultDividerStyleAttributes = {
  "border-color": "#ffffff",
  "border-style": "solid" as const,
  "border-width": "1px",
  "padding-top": "10px",
  "padding-right": "10px",
  containerWidth: 600,
};

export const TopolDividerBlockStyleAttributesSchema = z.object({
  "border-color": z
    .string()
    .catch(defaultDividerStyleAttributes["border-color"]),
  "border-style": z
    .string()
    .catch(defaultDividerStyleAttributes["border-style"]),
  "border-width": z
    .string()
    .catch(defaultDividerStyleAttributes["border-width"]),
  "padding-top": z
    .string()
    .or(z.number())
    .nullable()
    .catch(defaultDividerStyleAttributes["padding-top"]),
  "padding-right": z
    .string()
    .or(z.number())
    .nullable()
    .catch(defaultDividerStyleAttributes["padding-right"]),
  padding: z.string().optional().catch(undefined),
  "container-background-color": TopolColorSchema.optional().catch(undefined),
  "container-gradient": TopolColorBearingSchema.optional().catch(undefined),
  "padding-bottom": z.string().or(z.number()).nullish().catch(undefined),
  "padding-left": z.string().or(z.number()).nullish().catch(undefined),
});

export const TopolDividerBlockSchema = TopolBlockSchema.extend({
  tagName: z.literal("mj-divider"),
  attributes: z
    .object({
      ...TopolDividerBlockStyleAttributesSchema.shape,
      containerWidth: z
        .number()
        .catch(defaultDividerStyleAttributes["containerWidth"]),
      "css-class": TopolBlockCssClassSchema.optional().catch(undefined),
    })
    .default(defaultDividerStyleAttributes),
});

export type TopolDividerBlock = z.infer<typeof TopolDividerBlockSchema>;
